import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { dataportfolio, meta } from "../../content_option";

export const Project = () => {
  const { slug } = useParams();
  const project = dataportfolio.find((p) => p.slug === slug);

  if (!project) {
    return (
      <HelmetProvider>
        <Container className="About-header">
          <Row className="mb-5 mt-3 pt-md-3">
            <Col lg="8">
              <h1 className="display-4 mb-4">Project not found</h1>
              <hr className="t_border my-4 ml-0 text-left" />
              <Link to="/portfolio">← back to portfolio</Link>
            </Col>
          </Row>
        </Container>
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <Container className={`About-header ${project.layout === "side-by-side" ? "project__layout-side" : ""}`}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {project.title} | {meta.title}
          </title>
          <meta name="description" content={project.description} />
        </Helmet>

        <Row className="mb-4 mt-3 pt-md-3">
          <Col lg="10">
            <Link to="/portfolio" className="project__back">
              ← back to portfolio
            </Link>
            <h1 className="display-4 mb-2">{project.title}</h1>
            <p className="project__category">{project.category}</p>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        <Row className="sec_sp">
          <Col lg="8">
            <p className="project__desc">{project.description}</p>
          </Col>
        </Row>

        {project.hero && (
          <Row className="sec_sp">
            <Col lg="12">
              <img
                src={project.hero}
                alt={`${project.title} — final mockup`}
                className="project__hero"
              />
            </Col>
          </Row>
        )}

        {project.layout === "side-by-side" || project.layout === "pairs" ? (
          <Row className="sec_sp project__piece project__piece--side">
            {project.pieces.map((piece, i) => (
              <Col
                md={
                  project.layout === "pairs"
                    ? 6
                    : 12 / project.pieces.length
                }
                key={i}
                className="mb-4"
              >
                <h3 className="project__piece-label">{piece.label}</h3>
                <img
                  src={piece.img}
                  alt={piece.label}
                  className="project__piece-img"
                />
              </Col>
            ))}
          </Row>
        ) : (
          project.pieces.map((piece, i) => (
            <Row className="sec_sp project__piece" key={i}>
              <Col lg="12">
                <h3 className="project__piece-label">{piece.label}</h3>
                <img
                  src={piece.img}
                  alt={piece.label}
                  className="project__piece-img"
                />
              </Col>
            </Row>
          ))
        )}

        <Row className="sec_sp">
          <Col lg="8">
            <Link to="/portfolio" className="project__back">
              ← back to all projects
            </Link>
          </Col>
        </Row>
      </Container>
    </HelmetProvider>
  );
};
